"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var apps_shared_1 = require("@l2p/apps-shared");
var navigation_1 = require("next/navigation");
var CommonLimitReached = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var router = (0, navigation_1.useRouter)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var openLimitSettings = (0, react_1.useCallback)(function () {
        router.push(generateUrlWithLang('/account/profile/gambling-limits'));
    }, [router, generateUrlWithLang]);
    return (react_1.default.createElement(ui_components_1.Modal, { width: "450px", height: "auto", padding: "0", onClose: openLimitSettings, showClose: false },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('commonLimitReached.title')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.limitName }, t('commonLimitReached.description')))),
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: openLimitSettings, maxWidth: "335px", width: "100%" }, t('commonLimitReached.actionDescription')))));
};
exports.default = CommonLimitReached;
